import { render, staticRenderFns } from "./ImageRights.vue?vue&type=template&id=c0f28e20&scoped=true"
import script from "./ImageRights.vue?vue&type=script&lang=js"
export * from "./ImageRights.vue?vue&type=script&lang=js"
import style0 from "./ImageRights.vue?vue&type=style&index=0&id=c0f28e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f28e20",
  null
  
)

export default component.exports